<template>
    <div class="capital_content">
        <div class="capital_head_content">
            <div class="capital_head_left"><span>预存款余额：</span><small>{{cost}}</small><span>元</span></div>
            <div class="capital_head_right"><Button type="warning" @click="rechargebtn">充值</Button></div>
        </div>
        <div class="h6"></div>
        <div class="tabs_content">
            <ul>
                <li @click="orderjump(1)">支付记录</li>
                <li class="active">预存款收支明细</li>
            </ul>
        </div>
        <div class="capital_box">
            <div class="order_search_content">
                <div class="order_search_list">
                    <Input v-model="pclikename" search enter-button="搜索" placeholder="关联单号" @on-search="searchClick" style="width: 212px;" />
                </div>
                <div class="order_search_list">
                    <Select v-model="fundstatus" clearable style="width: 148px;" placeholder="收支类型" @on-change="searchClick">
                        <Option :value="0">全部</Option>
                        <Option :value="index" v-for="(item, index) in statuslist" :key="index">{{item}}</Option>
                    </Select>
                </div>
                <div class="order_search_list">
                    <Select v-model="status" clearable style="width: 148px;" placeholder="支付方式" @on-change="searchClick">
                        <Option :value="0">全部</Option>
                        <Option :value="index" v-for="(item, index) in paytype" :key="index">{{item}}</Option>
                    </Select>
                </div>
                <div class="order_search_list">
                    <DatePicker type="datetime" format="yyyy-MM-dd HH:mm" v-model="stardatetiem" placeholder="开始时间" @on-change="starChange" style="width: 148px;"></DatePicker>
                    <span class="order_search_spacer">~</span>
                    <DatePicker type="datetime" format="yyyy-MM-dd HH:mm" v-model="enddatetiem" placeholder="结束时间" @on-change="endChange" style="width: 148px;"></DatePicker>
                </div>
            </div>
            <div class="order_table_content">
                <Table
                    border
                    ref="selection"
                    :loading="tloading"
                    :columns="thead"
                    :data="goodslist"></Table>
            </div>
            <!-- 分页 -->
            <div class="page_content">
                <Page
                    :total="pagetotal"
                    :current="pagecurrent"
                    :page-size="pagesize"
                    :page-size-opts="pagesizeopts"
                    show-total
                    show-sizer
                    show-elevator
                    @on-change="pageChange"
                    @on-page-size-change="pageSizeChange" />
            </div>
        </div>
        <!-- 详情弹窗 -->
        <PayRecord :payrecordShow="payrecordShow" :payrecordtype="payrecordtype" :payrecordinfo="payrecordinfo" @payrecordCancel="payrecordCancel"></PayRecord>
        <noLoginTips :nologinShow="nologinShow" :nologintipsmsg="nologintipsmsg" @nologinOk="nologinOk" @nologinCancel="nologinCancel"></noLoginTips>
    </div>
</template>

<script>
import api from '@/request/api.js'
import PayRecord from '@/components/component/popup/payrecord.vue'
import noLoginTips from '@/components/component/popup/nologintips.vue'
export default {
    components: {PayRecord, noLoginTips},
    data() {
        return {
            tloading: false, // 表格加载中
            cost: 0, // 账户余额
            pclikename: '', // 订单号/商品名称
            status: '', // 订单状态
            fundstatus: '', // 付款状态
            paytype: {}, // 支付方式
            statuslist: {}, // 收款状态
            stardatetiem: '', // 开始时间
            enddatetiem: '', // 结束时间
            nologinShow: false, // 未登录弹窗是否显示
            nologintipsmsg: false, // 未登录弹窗信息
            payrecordShow: false, // 详情弹窗是否显示
            payrecordtype: 1, // 弹窗类型 0 支付记录 1 预存款收支明细
            payrecordinfo: {}, // 订单详情弹窗信息
            thead: [ // 表格头部
                {
                    width: 50,
                    type: 'index',
                    align: 'center'
                },
                {
                    title: '时间',
                    key: 'paytime'
                },
                {
                    title: '支付方式',
                    key: 'paytype'
                },
                {
                    title: '收款账号',
                    key: 'consignee',
                    render: (h, params) => {
                        return h('div',
                                    {
                                        class: 'order_table_name'
                                    },
                                    [
                                        h('span', params.row.accountbank),
                                        h('span', params.row.accountname),
                                        h('span', params.row.accountnum)
                                    ]
                                )
                    }
                },
                {
                    title: '收支类型',
                    key: 'typename'
                },
                {
                    title: '收、付款',
                    key: 'cost',
                    render: (h, params) => {
                        return h('span', params.row.typesign == 1 ? '+' + params.row.cost : '-' + params.row.cost)
                    }
                },
                {
                    title: '余额',
                    key: 'cuscost'
                },
                {
                    title: '关联单号',
                    key: 'dno'
                },
                {
                    title: '操作',
                    key: 'operation',
                    render: (h, params) => {
                        return h('div',
                                    {
                                        class: 'order_table_operation'
                                    },
                                    [
                                        h('span',
                                            {
                                                on: {
                                                    click: () => {
                                                        this.payrecordOk(params.row)
                                                    }
                                                },
                                            },
                                            '详情'
                                        )
                                    ]
                                )
                    }
                }
            ],
            goodslist: [],
            pagetotal: 0, // 分页总数
            pagesize: 30, // 分页每页条数
            pagesizeopts: [30, 60, 90], // 分页每页条数切换的配置[4, 8, 16][30, 60, 90]
            pagecurrent: 1, // 当前分页
        }
    },
    methods: {
        getInfo () { // 获取信息
            if (!this.$store.state.openmall) {
                this.tloading = true
                this.http.post(api.depositrecord,
                    {
                        dno: this.pclikename,
                        paytype: this.status,
                        type: this.fundstatus,
                        paytime: this.stardatetiem,
                        payendtime: this.enddatetiem,
                        page: this.pagecurrent,
                        pagesize: this.pagesize
                    }
                )
                .then(response => {
                    console.log(response.data.msg)
                    this.cost = response.data.msg.customer.cost
                    this.goodslist = response.data.msg.orderfund_orderfundlist
                    this.paytype = response.data.msg.paytype
                    this.statuslist = response.data.msg.type
                    this.pagetotal = response.data.msg.orderfund_pagecontent.num
                    this.tloading = false
                })
                .catch(error => {
                    console.log(error);
                })
            }
        },
        orderjump (sign) { // 跳转链接
            let link
            if (sign == 1) {
                link = '/PayRecordCapital'
            } else if (sign == 2) {
                link = '/DepositRecord'
            }
            this.$router.push(link)
        },
        searchClick () { // 点击搜索按钮
            this.pagecurrent = 1
            this.getInfo()
        },
        starChange (e) { // 搜索订单开始时间
            if (e > this.enddatetiem && this.enddatetiem != '') {
                this.$Message.warning('开始时间不能大于结束时间')
            } else if (this.enddatetiem != '') {
                this.stardatetiem = e
                this.pagecurrent = 1
                this.getInfo()
            } else {
                this.stardatetiem = e
            }
        },
        endChange (e) { // 搜索订单结束时间
            if (e < this.stardatetiem && this.stardatetiem != '') {
                this.$Message.warning('结束时间不能小于开始时间')
                this.enddatetiem = ''
            } else if (this.stardatetiem != '') {
                this.enddatetiem = e
                this.pagecurrent = 1
                this.getInfo()
            } else {
                this.enddatetiem = e
            }
        },
        pageChange (e) { // 分页翻页改变
            this.pagecurrent = e
            this.getInfo()
        },
        pageSizeChange (e) { // 分页每页条数改变
            this.pagecurrent = 1
            this.pagesize = e
            this.getInfo()
        },
        payrecordOk (item) { // 详情弹窗打开
            this.payrecordinfo = item
            this.payrecordShow = true
        },
        payrecordCancel () { // 详情弹窗关闭
            this.payrecordShow = false
        },
        rechargebtn () { // 充值余额
            if (!this.$store.state.openmall) {
                this.$router.push({
                    name: '支付',
                    params: {
                        type: 1,
                        id: 0,
                    }
                })
            } else {
                this.nologintipsmsg = '未登录客户不可充值，请登录'
                this.nologinShow = true
            }
        },
        nologinOk () {
            this.nologinShow = false
        },
        nologinCancel () {
            this.nologinShow = false
        }
    },
    created () {
        this.getInfo()
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/views/capital/depositrecord.vue